import { render, staticRenderFns } from "./dashboard-hotsale.vue?vue&type=template&id=1accccf6&scoped=true&"
import script from "./dashboard-hotsale.vue?vue&type=script&lang=js&"
export * from "./dashboard-hotsale.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-hotsale.vue?vue&type=style&index=0&id=1accccf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1accccf6",
  null
  
)

export default component.exports